import { useMemo } from "react";
import { CharacterResult } from "common/character/dto/CharacterResult";
import useTopicWork from "common/topic/provider/TopicWork";
import {
  isRadicalCharacterTopic,
  isWordExpressionTopic,
} from "common/topic/topic_tag_common";
import WordExpressionRelateContainNav from "./WordExpression/WordExpressionRelateContainNav";
import RadicalCharacterRelateContainNav from "./RadicalCharacter/RadicalCharacterRelateContainNav";

type CharacterRelateContainNavProps = {
  character: CharacterResult;
};

const CharacterRelateContainNav = ({
  character,
}: CharacterRelateContainNavProps) => {
  const { topicWork } = useTopicWork();
  const isRadicalCharacter = useMemo(
    () => (topicWork !== null ? isRadicalCharacterTopic(topicWork) : false),
    [topicWork]
  );
  const isWordExpression = useMemo(
    () => (topicWork !== null ? isWordExpressionTopic(topicWork) : false),
    [topicWork]
  );

  return (
    <>
      {isRadicalCharacter && (
        <RadicalCharacterRelateContainNav character={character} />
      )}
      {isWordExpression && (
        <WordExpressionRelateContainNav character={character} />
      )}
    </>
  );
};

export default CharacterRelateContainNav;
